import { Component, EventEmitter, forwardRef, HostListener, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Button } from '@dds-uicore/all';


const UI_SWITCH_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  /* tslint:disable-next-line: no-use-before-declare */
  useExisting: forwardRef(() => AccToggleComponent),
  multi: true
};

@Component({
  selector: 'app-acc-toggle',
  templateUrl: './acc-toggle.component.html',
  styleUrls: ['./acc-toggle.component.css'],
  providers: [UI_SWITCH_CONTROL_VALUE_ACCESSOR]

})
export class AccToggleComponent implements OnInit {
  // toggleValue = true
  // accelerationEnabled = true;
  // checked : any


  private _checked: boolean;
  private _disabled: boolean;
  private _reverse: boolean;

  @Input() size = 'medium';
  @Output() change = new EventEmitter<boolean>();
  @Input() labelOn = '';
  @Input() labelOff = '';

  @Input() set checked(v: boolean) {
    this._checked = v !== false;
  }
  constructor() { }

  ngOnInit(): void {
    // const toggleBtn = document.querySelectorAll("[data-toggle=\"dds__button\"]");
    // new Button(toggleBtn[0]);
  }

  // onChange()
  // {
  //   this.accelerationEnabled = !this.accelerationEnabled;
  //   console.log('acceleration enabled ? ',this.accelerationEnabled)
  // }


  
  get checked() {
    return this._checked;
  }

  @Input() set disabled(v: boolean) {
    this._disabled = v !== false;
  }

  get reverse() {
    return this._reverse;
  }

  @HostListener('click')
  onToggle() {
    if (this.disabled) {
      return;
    }
    this.checked = !this.checked;
    this.change.emit(this.checked);
    this.changed(this.checked);
    this.touched(this.checked);
  }

  // Implement control value accessor

  changed = (_: any) => {};

  touched = (_: any) => {};

  public writeValue(obj: any) {
    if (obj !== this.checked) {
      this.checked = !!obj;
    }
  }

  public registerOnChange(fn: any) {
    this.changed = fn;
  }

  public registerOnTouched(fn: any) {
    this.touched = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    //
  }

}
